<div class="good-item-page">
  <h1>Страница с полным описанием музыкального товара</h1>
  <p>
    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut beatae commodi culpa, debitis deleniti eos excepturi
    magnam nulla, odio officia officiis, quae quaerat quas quia quibusdam quis tempore! Distinctio, sit tempore! A
    adipisci aliquid consectetur consequatur cum cumque esse facilis fuga illo iusto, libero maiores mollitia odio odit
    porro quae, quo quod recusandae reiciendis repudiandae sed soluta, sunt unde ut voluptatum. Fugit numquam, omnis.
    Corporis cupiditate distinctio doloremque est fuga, iusto necessitatibus nulla perspiciatis quia quisquam rerum
    saepe sequi vero. Consequuntur corporis cum eum explicabo fugiat, libero modi mollitia, nisi quis rem repudiandae,
    sit tempora ut? Delectus, expedita illum! Eaque!
  </p>
</div>
